<script lang="ts">import { Api, loggedIn } from "@infinitro/global";
import { onDestroy, onMount } from "svelte";
import { derived, writable } from "svelte/store";
import { AsyncRaceCurrentInfo, AsyncRaceInfo, AsyncRaceLastInfo, AsyncRaceNextInfo } from "./api/api";
import InfoCardWithIllustrations from "./parts/info-card-with-illustrations.svelte";
import ParticipatingGames from "./parts/participating-games.svelte";
import PrizePool from "./parts/prize-pool.svelte";
import TermsAndConditions from "./parts/terms-and-conditions.svelte";
import TitleCard from "./parts/title-card.svelte";
export let raceId = "current";
let isMounted = writable(false);
let retryTimer = undefined;
let race = undefined;
const ready = derived([loggedIn, isMounted], ([$loggedIn, $isMounted]) => {
	return Boolean($isMounted === true && $loggedIn !== undefined);
});
// Re-fetch data when ready state changes OR when raceId changes
$: if ($ready && raceId !== undefined) {
	init();
}
const init = async () => {
	try {
		if (raceId === "current") {
			const result = await AsyncRaceCurrentInfo({ context: { api: $loggedIn === true ? Api.player : Api.public } });
			if (result.data?.raceCurrent) {
				race = result.data.raceCurrent;
			}
		} else if (raceId === "last") {
			const result = await AsyncRaceLastInfo({ context: { api: $loggedIn === true ? Api.player : Api.public } });
			if (result.data?.raceLast) {
				race = result.data.raceLast;
			}
		} else if (raceId === "next") {
			const result = await AsyncRaceNextInfo({ context: { api: $loggedIn === true ? Api.player : Api.public } });
			if (result.data?.raceNext) {
				race = result.data.raceNext;
			}
		} else {
			const result = await AsyncRaceInfo({
				variables: { raceId },
				context: { api: $loggedIn === true ? Api.player : Api.public }
			});
			if (result.data?.raceById) {
				race = result.data.raceById;
			}
		}
	} catch (err) {
		console.warn("Error fetching race data:", err);
		retryTimer = setTimeout(() => {
			init();
		}, 3e3);
	}
};
onMount(() => {
	isMounted.set(true);
});
onDestroy(() => {
	isMounted.set(false);
	if (retryTimer) {
		clearTimeout(retryTimer);
		retryTimer = undefined;
	}
});
</script>

<div class="main">
	{#if race}
		{#key raceId}
			<TitleCard {race} {raceId} />

			<InfoCardWithIllustrations {race} {raceId} />

			<ParticipatingGames {race} {raceId} />

			<PrizePool {race} {raceId} />

			<TermsAndConditions {race} {raceId} />
		{/key}
	{/if}
</div>

<style>
	.main {
		width: 100% !important;
	}
</style>
